export default __webpack_public_path__ + "static/media/1909.12375118.png";